/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../kubb/client";
import type { Client, RequestConfig, ResponseErrorConfig, ResponseConfig } from "../../../kubb/client";
import type { PostSmsVerifySendMutationRequest, PostSmsVerifySendMutationResponse, PostSmsVerifySend400, PostSmsVerifySend429, PostSmsVerifySend502 } from "../models/PostSmsVerifySend";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postSmsVerifySendMutationKey = () => [{ url: '/api/v1/sms/verify/send' }] as const

export type PostSmsVerifySendMutationKey = ReturnType<typeof postSmsVerifySendMutationKey>

/**
 * @description Sends a one-time code to the phone via Twilio Verify. Public/anonymous (works pre-lead); rate-limited per IP and per phone.
 * @summary Send SMS opt-in verification code
 * {@link /api/v1/sms/verify/send}
 */
export async function postSmsVerifySend({ data }: { data: PostSmsVerifySendMutationRequest }, config: Partial<RequestConfig<PostSmsVerifySendMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostSmsVerifySendMutationResponse, ResponseErrorConfig<PostSmsVerifySend400 | PostSmsVerifySend429 | PostSmsVerifySend502>, PostSmsVerifySendMutationRequest>({ method : "POST", url : `/api/v1/sms/verify/send`, data : requestData, ... requestConfig })
  return res
}

export function postSmsVerifySendMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostSmsVerifySendMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postSmsVerifySendMutationKey()
        return mutationOptions<ResponseConfig<PostSmsVerifySendMutationResponse>, ResponseErrorConfig<PostSmsVerifySend400 | PostSmsVerifySend429 | PostSmsVerifySend502>, {data: PostSmsVerifySendMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return postSmsVerifySend({ data }, config)
          },
        })

}

/**
 * @description Sends a one-time code to the phone via Twilio Verify. Public/anonymous (works pre-lead); rate-limited per IP and per phone.
 * @summary Send SMS opt-in verification code
 * {@link /api/v1/sms/verify/send}
 */
export function usePostSmsVerifySend<TContext>(options: 
{
  mutation?: UseMutationOptions<ResponseConfig<PostSmsVerifySendMutationResponse>, ResponseErrorConfig<PostSmsVerifySend400 | PostSmsVerifySend429 | PostSmsVerifySend502>, {data: PostSmsVerifySendMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostSmsVerifySendMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postSmsVerifySendMutationKey()

          const baseOptions = postSmsVerifySendMutationOptions(config) as UseMutationOptions<ResponseConfig<PostSmsVerifySendMutationResponse>, ResponseErrorConfig<PostSmsVerifySend400 | PostSmsVerifySend429 | PostSmsVerifySend502>, {data: PostSmsVerifySendMutationRequest}, TContext>
          

          return useMutation<ResponseConfig<PostSmsVerifySendMutationResponse>, ResponseErrorConfig<PostSmsVerifySend400 | PostSmsVerifySend429 | PostSmsVerifySend502>, {data: PostSmsVerifySendMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ResponseConfig<PostSmsVerifySendMutationResponse>, ResponseErrorConfig<PostSmsVerifySend400 | PostSmsVerifySend429 | PostSmsVerifySend502>, {data: PostSmsVerifySendMutationRequest}, TContext>
      
}